import { ReactNode, useState } from 'react';

import { createTypeSafeContext } from '~/core/utils';

interface ApplianceContextValue {
  isDraggingAppliance: boolean;
  onDropAppliance?: () => void;
  updateIsDraggingAppliance: (value: boolean) => void;
  updateOnDropAppliance: (onDropAppliance: (() => void) | undefined) => void;
}

export const [useApplianceContext, ApplianceContext] =
  createTypeSafeContext<ApplianceContextValue>();

export const ApplianceContextProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const [isDraggingAppliance, setIsDraggingAppliance] = useState(false);
  const [onDropAppliance, setOnDropAppliance] =
    useState<ApplianceContextValue['onDropAppliance']>(undefined);

  const updateIsDraggingAppliance = (value: boolean) => {
    setIsDraggingAppliance(value);
  };

  const updateOnDropAppliance = (
    func: ApplianceContextValue['onDropAppliance']
  ) => {
    setOnDropAppliance(() => func);
  };

  return (
    <ApplianceContext.Provider
      value={{
        updateIsDraggingAppliance,
        isDraggingAppliance,
        onDropAppliance,
        updateOnDropAppliance,
      }}
    >
      {children}
    </ApplianceContext.Provider>
  );
};
